<span class="effect" ref="text" v-observe><slot></slot></span>